import React, { ReactElement } from 'react';

import Link from 'buyside/components/presentation/Link/link';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';
import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';

import { ideaUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';

import { useHomePageTrendingIdeasQuery } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/ActivityFeedPage/homePageStyles.scss';

const HomePageTrendingIdeas = (): ReactElement => {
  const { data, loading } = useHomePageTrendingIdeasQuery();

  return (
    <div className={styles.trendingContainer}>
      <header>Trending Reports</header>
      <div className={styles.trendingIdeas}>
        {(loading || !data) && (
          <>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => (
              <div key={i} className={styles.ideaMiniCardLoading}>
                <Skeleton size={SKELETON_SIZES.LARGE} width={SKELETON_WIDTHS.TINY} />
              </div>
            ))}
          </>
        )}
        {data?.trendingIdeas?.edges?.map(edge => {
          if (!edge?.node) return null;

          const { id, positions, totalReturn } = edge.node;
          const isRedacted = positions[0].primarySymbol === 'Redacted';

          return (
            <div key={id} className={styles.ideaMiniCard}>
              {isRedacted ? (
                <div>
                  <RedactedDataPoint Wrapper="div" blurLeft="0px" overlayLeft="0px" />
                  <ReturnValue value={totalReturn} />
                </div>
              ) : (
                <Link to={ideaUrl(id)}>
                  <div className={styles.assetSymbol}>
                    {separateWithDots(positions.map(position => position.primarySymbol))}
                  </div>
                  <ReturnValue value={totalReturn} />
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomePageTrendingIdeas;
